export const enum RoutingPaths {
  Home = '/',
  Staking = '/staking',
  Vesting = '/vesting',
  Settings = '/settings',
  PrivateSale = '/private',
  PublicSale = '/public',
  SeedSale = '/seed',
}
